/**
 * Bearer-token guard for the Stage-2 upload route (5.0h). Stage-2 analog of
 * RequireCandidateSession — adapts the Wave A T-1 redirect pattern for the
 * sessionStorage `stage_2_token` model. Missing token → toast + Navigate back to the
 * consent index (NOT /login — candidates never see the admin login).
 *
 * In normal flow the layout has already persisted the URL token, so this guard passes;
 * it defends the deep-link case where the token is absent/cleared (e.g., expired-session
 * 401 cleared it) and the candidate lands on /upload without a live token.
 */
import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { getStage2SessionToken } from "@/features/candidate-stage2/api";

export default function RequireStage2Session() {
  const { stage2Token } = useParams<{ stage2Token: string }>();
  const { t } = useTranslation("candidate-stage2");
  const sessionToken = getStage2SessionToken();

  useEffect(() => {
    if (!sessionToken) {
      toast.error(t("errors.session_expired"));
    }
  }, [sessionToken, t]);

  if (!sessionToken) {
    return <Navigate to={`/c/stage2/${stage2Token}`} replace />;
  }
  return <Outlet />;
}
